var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSpiritoIconOrange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.14 29.855"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 1",
    d: "M11.874 28.028v-.392h1.7a10.525 10.525 0 0010.569-10.569v-2.479a3.125 3.125 0 013 3 3.221 3.221 0 01-2.61 3.131 11.359 11.359 0 01-9 7.7 1.957 1.957 0 01-1.827 1.435 1.784 1.784 0 01-1.832-1.826zm-7.7-10.831a9.312 9.312 0 012.219-6.133L17.353.104a.577.577 0 01.913.391v7.177a.753.753 0 001.305.522l2.348-2.349c.391-.392.914-.13.783.261v10.96a9.273 9.273 0 01-9.133 9.265h-.232a9.308 9.308 0 01-9.162-9.133zm11.613-.783v1.958a.417.417 0 00.391.391h1.827a.417.417 0 00.391-.391h.13v-1.958a.417.417 0 00-.391-.391h-1.958a.417.417 0 00-.386.392zm-6.394 0v1.958a.417.417 0 00.391.391h1.958a.417.417 0 00.391-.391v-1.958a.417.417 0 00-.391-.391H9.791a.417.417 0 00-.4.392zM-.001 17.72a3.249 3.249 0 013-3.132v6.263A3.15 3.15 0 010 17.721z",
    fill: "#ee6324"
  })));
}

export default __webpack_public_path__ + "a373cacbee5d65a867de44c56fdea136.svg";
export { SvgSpiritoIconOrange as ReactComponent };